var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"placeholder":_vm.field.placeholder,"type":"textarea","autosize":""},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }